import { InjectionToken } from '@angular/core';

export interface SsrContext {
    status: number;
}

export const SSR_CONTEXT = new InjectionToken<SsrContext>('SSR_CONTEXT');